import React from 'react';
import GeneralLayout from '../layout/GeneralLayout';
import LoginForm from '../Components/LoginForm';
import GoogleLogin from '../Components/GoogleLogin';

export default function Login() {


  return (
    <GeneralLayout>
      <LoginForm />
      <GoogleLogin />
    </GeneralLayout>
  );
}
